module.exports = function ( val ) {
	if ( Number.isInteger(val) == false && val.indexOf('/') > 0 ){
		return window.matchMedia("only screen and (max-aspect-ratio: " + val + ")").matches;
	}
	if ( val < 0 ) {
		return window.matchMedia("only screen and (max-width: " + Math.round(val * -1) + "px)").matches;
	}
	return window.matchMedia("only screen and (min-width: "+val+"px)").matches;
};